<template>
  <div class="footer-language">
    <div class="footer-content">
      <LanguageSwitcher />
    </div>
  </div>
</template>
<script setup>
import LanguageSwitcher from '@shared/components/LanguageSwitcher.vue'
</script>

<style lang="scss" scoped>
.footer-language {
  .footer-content {
    // vertically offset the padding of the language switcher
    padding: $kds-space-1_5x $kds-space-2_5x;
    margin: auto;
    max-width: $br-xl;
  }
}
</style>
